import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentification.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()

export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService,
                private toastr : ToastrService,
                private router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
          if (err.status === 401) {
            this.authenticationService.removeCurrentUser();
            if(this.router.url !== '/signin'){
              this.router.navigate(['/signin'])
              this.toastr.error('action non authorisée veuillez vous reconnecter !!!')
            }
          }
            const error = err.error.message || err.statusText;
            return throwError(error);
        }))
    }
}
